export const ColourComponent = ({ colourCode, colourName }) => {
    return (
        <div>
            <div
                style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '100%',
                    backgroundColor: colourCode,
                }}></div>
            {`${colourName}`}
        </div>
    );
};
